export const config = {
  siteUrl: import.meta.env.PUBLIC_SITE_URL ?? "",
  turnstileSiteKey: import.meta.env.PUBLIC_TURNSTILE_SITE_KEY ?? "",
  logoPath: import.meta.env.PUBLIC_LOGO_PATH ?? "/assets/alkayan-logo-mark.jpg",
  companyLegalNameAr:
    import.meta.env.COMPANY_LEGAL_NAME_AR ?? "شركة كيان الاستشارات الهندسية",
  valuationUnitNameAr:
    import.meta.env.VALUATION_UNIT_NAME_AR ?? "وحدة تقييم الأصول العقارية",
  combinedUnitNameAr:
    import.meta.env.COMBINED_UNIT_NAME_AR ??
    "وحدة تقييم الأصول العقارية — شركة كيان الاستشارات الهندسية",
  contactEmail: import.meta.env.CONTACT_EMAIL ?? "info@alkayan-eng.com",
  contactSecondaryEmail:
    import.meta.env.CONTACT_SECONDARY_EMAIL ?? "contact@alkayan-eng.com",
  contactPhone: import.meta.env.CONTACT_PHONE ?? "",
  contactAddress: import.meta.env.CONTACT_ADDRESS ?? "",
};

export const hasContactData = Boolean(
  config.contactEmail ||
    config.contactSecondaryEmail ||
    config.contactPhone ||
    config.contactAddress,
);
